"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.addWidgetPanel = void 0;
const command_manager_1 = require("../../command_manager");
const i18n_1 = require("../../exports/i18n");
const model_1 = require("../../model");
const selectors_1 = require("../../exports/store/selectors");
const types_1 = require("../../types");
const utils_1 = require("../../utils");
exports.addWidgetPanel = {
    undoable: false,
    execute(context, options) {
        const { model: state } = context;
        const { resourceId, resourceType } = options;
        const snapshot = resourceType === types_1.ResourceType.Datasheet ? (0, selectors_1.getSnapshot)(state, resourceId) : (0, selectors_1.getMirrorSnapshot)(state, resourceId);
        const widgetPanels = (resourceType === types_1.ResourceType.Datasheet ? snapshot.meta.widgetPanels :
            snapshot.widgetPanels) || [];
        const panelCount = widgetPanels.length;
        if (panelCount > 2) {
            return null;
        }
        const existPanelIds = widgetPanels.map(item => {
            return item.id;
        });
        const existPanelName = widgetPanels.map(item => {
            return item.name;
        });
        const newPanelId = (0, utils_1.getNewId)(utils_1.IDPrefix.WidgetPanel, existPanelIds);
        const newPanelName = (0, utils_1.getUniqName)((0, i18n_1.t)(i18n_1.Strings.widget_panel), existPanelName);
        const generateStdValue = (id, name) => {
            return {
                name,
                id: id,
                widgets: [],
            };
        };
        const addWidgetPanelAction = resourceType === types_1.ResourceType.Datasheet ?
            model_1.DatasheetActions.addWidgetPanel2Action(snapshot, generateStdValue(newPanelId, newPanelName)) :
            model_1.DatasheetActions.addWidgetPanelWithMirror2Action(snapshot, generateStdValue(newPanelId, newPanelName));
        if (!addWidgetPanelAction) {
            return null;
        }
        return {
            result: command_manager_1.ExecuteResult.Success,
            resourceId: resourceId,
            resourceType: resourceType,
            actions: addWidgetPanelAction,
            data: {
                panelId: newPanelId,
            },
        };
    },
};
//# sourceMappingURL=add_widget_panel.js.map